export const LogoMark = ({ className = "w-10 h-10" }) => (
  <span className={`inline-block rounded-md overflow-hidden bg-white shrink-0 ${className}`}>
    <img
      src="/logo-mark.png"
      alt="PRO PRINT SOLUTION LLP logo"
      className="w-full h-full object-cover"
    />
  </span>
);

export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3">
      <LogoMark />
      {!compact && (
        <span className="leading-none">
          <span className="block font-display font-semibold tracking-tight text-paper text-lg">
            PRO PRINT
          </span>
          <span className="block font-mono text-[10px] tracking-[0.35em] text-mist mt-1">
            SOLUTION LLP
          </span>
        </span>
      )}
    </span>
  );
}
